export const year2018 = [
  { year: '2018' },
  {
    author: 'Chris Achard',
    name: 'Progressive Web Apps in React with create-react-app',
    link:
      'https://egghead.io/courses/progressive-web-apps-in-react-with-create-react-app',
    repo: 'https://github.com/andreidobrinski/todo-pwa-course',
    type: 'Egghead Course',
  },
  {
    author: 'Nik Graf',
    name: 'GraphQL Data in React with Apollo Client',
    link: 'https://egghead.io/courses/graphql-data-in-react-with-apollo-client',
    repo:
      'https://github.com/andreidobrinski/graphql-apollo-client-course-egghead',
    type: 'Egghead Course',
  },
  {
    author: 'Codecademy',
    name: 'Learn Color Design',
    link: 'https://www.codecademy.com/learn/learn-color-design',
    type: 'Course',
  },
  {
    author: 'Peter Cottle',
    name: 'Learn Git Branching',
    link: 'https://learngitbranching.js.org/',
    type: 'Mini-Course',
  },
  {
    author: 'Zach Goldstein',
    name: 'Penrose Triangle with Three.js',
    link: 'https://github.com/zachgoldstein/penroseTriangle',
    type: 'Workshop',
  },
  {
    author: 'Taylor Bell',
    name: 'Build a Blog with React and Markdown using Gatsby',
    link:
      'https://egghead.io/courses/build-a-blog-with-react-and-markdown-using-gatsby',
    repo: 'https://github.com/andreidobrinski/blog-tutorial-gatsby',
    type: 'Egghead Course',
  },
  {
    author: 'Stephen Grider',
    name: 'The Coding Interview Bootcamp',
    link:
      'https://www.udemy.com/coding-interview-bootcamp-algorithms-and-data-structure/',
    repo: 'https://github.com/andreidobrinski/AlgoCasts',
    type: 'Course',
  },
  {
    author: 'Matt Gaunt (Google CodeLabs)',
    name: 'Adding Push Notifications to a Web App',
    link:
      'https://developers.google.com/web/fundamentals/codelabs/push-notifications/',
    repo: 'https://github.com/andreidobrinski/web-push-codelab',
    type: 'Tutorial',
  },
  {
    author: 'Wes Bos',
    name: 'Mastering Markdown',
    link: 'https://masteringmarkdown.com',
    type: 'Mini Course',
  },
  {
    author: 'RegexOne',
    name: 'Learn Regular Expressions',
    link: 'https://regexone.com/',
    type: 'Lessons',
  },
  {
    author: 'Designlab',
    name: 'Figma 101',
    link: 'https://trydesignlab.com/figma-101-course/',
    type: 'Course',
  },
  {
    author: 'Monarch Haveri',
    name: 'React 101',
    link: 'https://github.com/monarchjhaveri/react101',
    repo: 'https://github.com/andreidobrinski/react101',
    type: 'Workshop',
  },
  {
    author: 'Kent C. Dodds',
    name: 'Testing React Applications',
    link: 'https://frontendmasters.com/courses/testing-react/',
    repo: 'https://github.com/andreidobrinski/testing-workshop',
    type: 'Workshop',
  },
  {
    author: 'Kent C. Dodds',
    name: 'Advanced React Patterns',
    link: 'https://frontendmasters.com/courses/advanced-react-patterns/',
    repo: 'https://github.com/andreidobrinski/advanced-react-patterns-v2',
    type: 'Workshop',
  },
  {
    author: 'Wes Bos',
    name: 'CSS Grid',
    link: 'https://cssgrid.io/',
    repo: 'https://github.com/andreidobrinski/css-grid',
    type: 'Course',
  },
  {
    author: 'Stephen Grider',
    name: 'Modern React and Redux',
    link: 'https://www.udemy.com/react-redux/',
    repo: 'https://github.com/andreidobrinski/modern-react-redux-course',
    type: 'Course',
  },
  {
    author: 'Taras Mankovski',
    name: 'Microstates Workshop',
    link: 'https://github.com/taras/microstates-workshop',
    repo: 'https://github.com/andreidobrinski/microstates-workshop',
    type: 'Workshop',
  },
];